module.exports = __webpack_public_path__ + "static/img/acttrader_platform.9e39e9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/acttrader_platform.png
// module id = 2SAJ
// module chunks = 4